<template>
    <div class="chaton-floatchat chaton-whatsappfloat" :id="`whatsappchat_${chatInfo.chatId}`">
        <div v-if="chatonLayout == 'layout2'" class="chaton-floatchat_content chaton-whatsappchat chaton-widget-box">
            <div class="chaton-floatchat_title chaton-floatchat_titlev2">
                <figure class="chaton-singleimg" :class="{'chaton-notavailable' : !chatInfo.isOnline}">
                    <img :src="chatInfo.userAvatar ? chatInfo.userAvatar : defaultAvatar" :alt="chatInfo.userName">
                    <span class="chaton-userstatus" :class="chatInfo.isOnline ? 'online' : 'offline'"></span>
                </figure>
                <div class="chaton-whatsapptitle">
                    <h2 v-if="chatInfo.userName">{{ chatInfo.userName | capitalize }}</h2>
                    <div class="chaton-floatchat_title-right">
                        <a href="javascript:void(0);"><i class="chatonicon chaton-x" @click.prevent="closeWidgetChatbox()" ></i></a>
                    </div>
                </div>
            </div>
            <div class="chaton-messagewrap" :style="chatBackround" >
                <div v-if="isLoading" class="chaton-msgautotyper">
                    <img :src="typingIcon" :alt="TRANS.whatsapp_loading_msg">
                </div>
                <div v-else class="chaton-messages">
                    <div class="chaton-message"> 
                        <span v-linkified v-html="userMessageText"></span> 
                        <span class="chaton-message_time">{{currentTime}}</span>
                    </div>
                </div>
            </div>
            <div class="chaton-replay">
                <send-text-message />
                <span><a v-if="getMessageInput" @click.prevent="sendTextMessage()" href="javascript:void(0);" class="chaton-sendmsg"><i class="chatonicon chaton-send"></i></a></span>
            </div>
        </div>

        <div v-else class="chaton-floatchat_content chaton-whatsappchat chaton-widget-box">
            <div class="chaton-iconclosered">
                <a href="javascript:void(0);"
                    class="chaton-removechat"
                    :class="{'chaton-backtolist' : isShowCloseButton }"
                    ><i class="chatonicon chaton-x" @click.prevent="closeWidgetChatbox()" ></i></a>
            </div>
            <div class="chaton-sidebarhead chaton-sidebarheadtwo">
                <h2>{{TRANS.layout1_widget_hdr_txt}}</h2>
                <p v-html="widgetboxHeaderText1"></p>
                <whatsapp-image :ImageColor="'lightGreen'" />
            </div>
            <div class="chaton-widgetlayoutone" :style="chatBackround">
                <div v-if="isLoading" class="chaton-msgautotyper">
                    <img :src="typingIcon" :alt="TRANS.whatsapp_loading_msg">
                </div>
                <div v-else class="chaton-howtoassist">
                    <figure class="chaton-userbar_profile chaton-profileuserstatus" :class="{'chaton-notavailable' : !chatInfo.isOnline}">
                        <img :src="chatInfo.userAvatar ? chatInfo.userAvatar : defaultAvatar" :alt="chatInfo.userName">
                        </figure>
                    <div class="chaton-userbar_title">
                        <h3>{{ chatInfo.userName | capitalize }}</h3>
                        <p v-linkified v-html="userMessageText"></p>
                        <span>{{currentTime}}</span>
                    </div>
                </div>
            </div>
            <div class="chaton-replay">
                <send-text-message />
                <span><a v-if="getMessageInput" @click.prevent="sendTextMessage()" href="javascript:void(0);" class="chaton-sendmsg"><i class="chatonicon chaton-send"></i></a></span>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import SendTextMessage from "../SendTextMessage/SendTextMessage.vue"
    const CHATON_SETTINGS = window.chaton_scripts_vars.chatSetting;
    import AVATAR from "../resources/avatar.png";
    import WhatsappImage from "../WhatsappUsers/WhatsappImage.vue";
    import jQuery from 'jquery';
    export default {
        name : 'WidgetChatBox',
        components : {
            SendTextMessage,
            WhatsappImage
        },
        data(){
            return {
                defaultAvatar       : AVATAR,
                currentTime         : moment().format("LT"),
                typingIcon          : CHATON_SETTINGS.typingIcon,
                whatsappBackground  : CHATON_SETTINGS.chatonBackground,
                chatonLayout        : CHATON_SETTINGS.chatonLayout,
                backgroundColor     : CHATON_SETTINGS.backgroundColor
            }
        },
        computed:{
            whatsappText(){
                let text = CHATON_SETTINGS.translations.whatsapp_support_desc;
                let convName = '<span>'+CHATON_SETTINGS.translations.conversation_name_txt+'</span>';
                return text.replace('{{conversation_name}}', convName);
            },
            widgetboxHeaderText1(){
                let text = CHATON_SETTINGS.translations.layout1_widget_dsc;
                let convName = '<span>'+CHATON_SETTINGS.translations.conversation_name_txt+'</span>';
                return text.replace('{{conversation_name}}', convName);
            },
            isShowCloseButton() {
                let windowWidth = this.$store.state.windowWidth
                if(windowWidth > 0 && windowWidth <= 768){
                    return true
                }
                return false
            },
            chatBackround(){
                if(this.whatsappBackground){
                    return { backgroundImage : `url(${this.whatsappBackground})` }
                }
                return { backgroundColor : this.backgroundColor };
            },
            chatInfo(){
                return this.$store.getters.getChatInfo;
            },
            getMessageInput(){
                return this.$store.getters.getMessageInput;
            },
            userMessageText(){
                let chatInfo = this.$store.getters.getChatInfo;
                if(Object.keys(chatInfo).length){
                    return chatInfo.isOnline ? chatInfo.userDefaultMessage : chatInfo.userOfflineMessage
                }
                return '';
            }
        },
        watch:{
            chatInfo(newVal, oldVal){
                if(newVal.chatId != oldVal.chatId){
                    if(newVal.isOnline){
                        this.isLoading = true;
                        this.loadingMessage();
                    }
                }
            }
        },
        methods:{
            sendTextMessage(){
                document.getElementById(`input-text-message-${this.chatInfo.chatId}`).focus();
                this.$root.$emit('openWhatsapp', {chatId : this.chatInfo.chatId});
            },
            closeWidgetChatbox(){
                jQuery(`#whatsappchat_${this.chatInfo.chatId}`).addClass('chaton-minimizefloatchat');
                this.$store.commit('updateChatInfo', {});
            },
            loadingMessage(){
                setTimeout(()=>{
                    this.isLoading = false;
                },2000);
            }
        },
        created(){
            if(this.chatInfo.isOnline){
                this.isLoading = true;
                this.loadingMessage()
            }
        }
    }
</script>

<style>

.chaton-whatsappchat .chaton-messagewrap{
    height: 100%;
    padding: 30px;
    min-height: auto;
    max-height: 100%;
    overflow: auto;
    background-size: cover;
    background-repeat: no-repeat;
}
.chaton-whatsappchat .chaton-messages{
    padding: 0;
}
.chaton-whatsappchat .chaton-message{
    font-size: 15px;
    max-width: 100%;
    line-height: 22px;
    padding: 20px 20px 14px 20px; 
    letter-spacing: 0.5px;
}
.chaton-whatsappchat .chaton-message span{
    margin: 0;
}

.chaton-whatsappchat .chaton-messagewrap > img{
    padding: 30px;
    display: block;
}
.chaton-messages {
    width: 100%;
    float: left;
    padding: 3px 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.chaton-floatchat{
    bottom: 0;
    right: 500px;
    width: 350px;
    z-index: 9999;
    position: fixed;
    overflow: hidden;
    transition: all 0.3s linear;
    filter: drop-shadow(0px 2px 4px rgba(40, 41, 61, 0.04)) drop-shadow(0px 8px 16px rgba(96, 97, 112, 0.16));
}
.chaton-floatchat_title {
  width: 100%;
  z-index: 9999;
  display: flex;
  min-height: 54px;
  align-items: center;
  background: var(--secwhatsappcolor);
  padding: 15px 20px;
  position: relative;
  border-radius: 10px 10px 0px 0px;
}
.chaton-floatchat_title h2 {
  margin: 0;
  color: #fff !important;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  padding-top: 0;
  padding-right: 20px;
  margin: 0;
  display: flex;
  align-items: center;
  overflow: hidden;
}
.chaton-floatchat_content {
    width: 100%;
    height: 100vh;
    max-height: 427px;
    display: flex;
    flex-direction: column;
    background-color: #F7F7F7;
    border-radius: 10px 10px 0 0;
}
.chaton-floatchat_title figure{
  margin: 0 10px 0 0;
  position: relative;
  flex: none;
}
.chaton-floatchat_title figure.chaton-notavailable .chaton-userstatus.offline{
    filter: grayscale(1) !important;
}

.chaton-singleimg img{
  width: 30px;
  height: 30px;
  display: block;
  border-radius: 50%;
}
.chaton-whatsapptitle {
    width: 100%;
    display: flex;
    align-items: center;
}
.chaton-whatsapptitle > h2 {
    display: block;
}
.chaton-floatchat_title-right {
    display: flex;
    align-items: center;
    margin-left: auto;
}
.chaton-floatchat_title-right a {
    line-height: 1;
    font-size: 28px;
    color: #fff;
    text-decoration: none;
}
.chaton-floatchat_titlev2 {
  flex: none;
  padding-top: 15px;
  padding-bottom: 15px;
  background-color: var(--themewhatsappcolor);
}
.chaton-floatchat_titlev2 > img{
  border-radius: 50%;
  max-width: 40px;
  max-height: 40px;
  object-fit: cover;
  margin-right: 10px;
}
.chaton-chatblockuser span:not(.chaton-message_time), .chaton-message, .chaton-userbar_loader span {
  -webkit-box-shadow: 0px 2px 4px rgba(40, 41, 61, 0.04), 0px 8px 16px rgba(96, 97, 112, 0.16);
  box-shadow: 0px 2px 4px rgba(40, 41, 61, 0.04), 0px 8px 16px rgba(96, 97, 112, 0.16);
}
.chaton-chat_previewfloat .chaton-message,
.chaton-floatchat_content .chaton-message{border-radius: 0px 10px 10px 10px;}
.chaton-message {
  white-space: pre-wrap;
  max-width: 75%;
  word-break: break-word;
  position: relative;
  color: var(--secwhatsappcolor);
  border-radius: 0px 20px 20px 20px;
  background-color: #fff;
  padding: 19px 20px;
  display: inline-block;
  margin: 0;
  font-size: 15px;
  line-height: 28px;
}
.chaton-message_time {
  display: block;
  font-size: 13px;
  margin-top: 6px;
  line-height: 30px;
  letter-spacing: 0.5px;
  color: var(--terwhatsappcolor);
  white-space: pre-line;
}
.chaton-replay {
    background-color: #fff;
    position: relative;
    margin-top: auto;
    padding: 20px;
    display: flex;
    align-items: center;
}
.chaton-replay_msg {
    flex: auto;
    display: flex;
    padding: 0 10px;
    position: relative;
    align-items: center;
}
.chaton-whatsappchat .chaton-replay_msg {
    padding: 0;
}
.chaton-sendmsg{
    text-decoration: none;
}
.chaton-send {
    width: 40px;
    color: #fff;
    display: block;
    font-size: 18px;
    line-height: 40px !important;
    text-align: center;
    margin-left: 10px;
    border-radius: 20px;
    background: var(--themewhatsappcolor);
}
.chaton-msgautotyper {
    display: inline-flex;
    padding: 9px 14px 14px;
    background-color: #fff;
    border-radius: 0px 15px 15px 15px;
    box-shadow: 0px 2px 4px rgb(40 41 61 / 4%), 0px 8px 16px rgb(96 97 112 / 16%);
}
.chaton-msgautotyper img {
    display: block;
    max-width: 18px;
}
.chaton-widgetclose ~ .chaton-chatfloatholder .chaton-floatchat {
    right: 165px;
}
.chaton-singleimg .chaton-userstatus {
    position: absolute;
    right: 0;
    bottom: 0;
    border: 3px solid var(--secwhatsappcolor);
    border-radius: 50%;
}
.chaton-floatchat_titlev2 .chaton-singleimg .chaton-userstatus {
    border-color: var(--themewhatsappcolor);
}
.chaton-floatchat_content .chaton-userstatus {
  display: flex;
  font: 400 0.8125rem/1.6153846154em "Open Sans", sans-serif;
}
.chaton-sidebarhead.chaton-sidebarheadtwo{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 16px 16px 16px 67px;
    border-radius: 20px 20px 0 0;
}
.chaton-sidebarhead.chaton-sidebarheadtwo svg{
    position: absolute;
    left: 0;
    opacity: 0.5;
}
.chaton-sidebarhead.chaton-sidebarheadtwo p{
    font-weight: 400;
    font-size: 15px;
    line-height: 22px;
    color: #fff;
    font-family: var(--secchatfont);
}
.chaton-sidebarhead.chaton-sidebarheadtwo p span {
    font-weight: 700;   
} 
.chaton-sidebarhead.chaton-sidebarheadtwo h2{
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    margin-bottom: 4px;
}
.chaton-layout-one .chaton-floatchat {
    right: 443px;
    overflow: visible;

}
.chaton-layout-one .chaton-replay_msg textarea.chaton-form-control {
    padding: 8px 0 0 0;
    border: 0;
}
.chaton-layout-one .chaton-replay {
     border-radius: 0;
    padding: 10px 20px 10px 20px;
}
.chaton-howtoassist{
    display: flex;
    align-items: flex-start;
    padding: 20px 20px 14px;
    background: #fff;
    border-radius: 20px 20px 20px 0px;
    position: relative;
}
.chaton-howtoassist .chaton-userbar_profile{
    max-width: 40px;
    height: 40px;
}
.chaton-howtoassist .chaton-userbar_title {
    margin-left: 10px;
    display: flex;
    flex-direction: column;

}
.chaton-howtoassist .chaton-userbar_profile img{
    max-width: 40px;
    height: 40px;
}
.chaton-howtoassist .chaton-notavailable{
    filter: grayscale(1);
}
.chaton-howtoassist .chaton-userbar_title p{
    font-size: 15px;
    color: #0A0F26;
    font-family: var(--secchatfont);
    white-space: pre-line;
}
.chaton-howtoassist .chaton-userbar_title span{
    font-weight: 400;
    font-size: 13px;
    line-height: 23px;
    color: #999999;
    font-family: var(--secchatfont);
}
.chaton-layout-one .chaton-floatchat_content {
    background:transparent;
    height: 100%;

}
.chaton-howtoassist::after{
    position: absolute;
    left: 0;
    content: '';
    bottom: -20px;
    display: inline-block;
    z-index: 1111;
    width: 0;
    height: 0;
    border-top: 20px solid #fff;
    border-right: 20px solid transparent;
}
.chaton-removechat i {
    color: #fff;
    font-size: 20px;
    width: 30px;
    height: 30px;
    background: #EF4444;
    text-decoration: none;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;
}
.chaton-layout-one .chaton-iconclosered {
    display: flex;
    width: auto;
    justify-content: flex-end;
    top: -10px;
    position: relative;
}
.chaton-layout-one .chaton-iconclosered a {
    text-decoration: none;
}
.chaton-widgetlayoutone{
    padding: 20px 20px 51px;
    height: 100%;
    min-height: 161px;
    max-height: 100%;
    overflow: auto;
    background-size: cover;
    background-repeat: no-repeat;
}
</style>